import {
  listBlackBoxStacks,
  createUserStack,
  editStackName,
} from '../../graphql/graphql';
import { fetchItemsNextToken } from '../../graphql/query-helpers';
import { client } from '../../amplify';

export const stackService = {
  load,
  create,
  edit,
};

// Resolves to the user's stacks, each carrying its own (non-deleted) links.
// This used to also run listOrigamiLinks in parallel: a flat scan of the whole
// links table with no owner key, paginated serially, that returned the same
// links already nested here. The store is filled from the nesting instead.
async function load() {
  const qparams = {
    limit: 1000,
  };

  return fetchItemsNextToken({
    query: listBlackBoxStacks,
    variables: qparams,
  });
}

async function create(boxId, name) {
  return client.graphql({
    query: createUserStack,
    variables: { boxId: boxId, private: true, name: name },
  });
}

async function edit(stackId, name) {
  return client.graphql({
    query: editStackName,
    variables: { id: stackId, name: name },
  });
}
